import React, { useEffect, useState } from "react";
import Field from "@/components/shared/ui/Field";
import Input from "@/components/shared/ui/Input";
import { FiHash, FiType, FiImage } from "react-icons/fi";

export type EditAirlinePayload = {
  code: string;
  name: string;
  logoPath?: string;
};

export type EditAirlineProps = {
  id: number | string;
  code: string;
  name: string;
  logoPath?: string;
};

export default function UpdateAirline({
  airline,
  onSubmit,
  onCancel,
}: {
  airline: EditAirlineProps;
  onSubmit: (payload: EditAirlinePayload) => void;
  onCancel?: () => void;
}) {
  const [form, setForm] = useState<EditAirlinePayload>({
    code: airline.code,
    name: airline.name,
    logoPath: airline.logoPath ?? "",
  });

  useEffect(() => {
    setForm({ code: airline.code, name: airline.name, logoPath: airline.logoPath ?? "" });
  }, [airline]);

  const change = <K extends keyof EditAirlinePayload>(k: K, v: EditAirlinePayload[K]) =>
    setForm((p) => ({ ...p, [k]: v }));

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    const code = (form.code ?? "").trim().toUpperCase();
    const name = (form.name ?? "").trim();
    if (!code || !name) return;
    onSubmit({ code, name, logoPath: form.logoPath?.trim() || "" });
  };

  return (
    <form onSubmit={submit} className="grid grid-cols-1 gap-4">
      <Field label="Airline code" icon={<FiHash />}>
        <Input value={form.code} onChange={(e) => change("code", e.target.value)} placeholder="e.g., AC, EK" required />
      </Field>
      <Field label="Airline name" icon={<FiType />}>
        <Input value={form.name} onChange={(e) => change("name", e.target.value)} placeholder="e.g., Air Canada" required />
      </Field>
      <Field label="Logo path" icon={<FiImage />}>
        <Input value={form.logoPath ?? ""} onChange={(e) => change("logoPath", e.target.value)} placeholder="assets/airlines/logo/AC.gif" />
      </Field>

      <div className="mt-3 flex justify-end gap-2">
        <button type="button" className="rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm text-gray-700 hover:bg-gray-50" onClick={() => onCancel?.()}>Cancel</button>
        <button type="submit" className="rounded-lg bg-sky-600 px-3 py-2 text-sm font-semibold text-white hover:bg-sky-700">Save Changes</button>
      </div>
    </form>
  );
}
